import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ThemeContext = createContext();

const DEFAULT_THEME = {
  name: 'General',
  image_url: 'https://static.prod-images.emergentagent.com/jobs/e0544b5f-c06a-4449-884b-1903f7719eb1/images/02dbf003c840bf86f8c3f11a92668c20bfbd8af9104c006286d37718184ba589.png',
  blur: 3,
  opacity: 0.45,
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(DEFAULT_THEME);

  const refreshTheme = useCallback(() => {
    axios.get(`${API}/theme/debug?_t=${Date.now()}`).then(r => {
      if (r.data?.name) setTheme(r.data);
    }).catch(() => {});
  }, []);

  useEffect(() => { refreshTheme(); }, []);

  // Listen for theme-changed events (dispatched from admin panel)
  useEffect(() => {
    const handler = () => refreshTheme();
    window.addEventListener('theme-changed', handler);
    window.addEventListener('focus', handler);
    return () => { window.removeEventListener('theme-changed', handler); window.removeEventListener('focus', handler); };
  }, [refreshTheme]);

  // Apply theme to CSS variables
  useEffect(() => {
    const root = document.documentElement;
    const imgUrl = theme.image_url?.startsWith('/api/')
      ? `${process.env.REACT_APP_BACKEND_URL}${theme.image_url}`
      : theme.image_url;
    root.style.setProperty('--theme-bg-image', imgUrl ? `url('${imgUrl}')` : 'none');
    root.style.setProperty('--theme-bg-blur', `${theme.blur || 3}px`);
    root.style.setProperty('--theme-bg-opacity', `${theme.opacity || 0.45}`);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, refreshTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
